export default __webpack_public_path__ + "static/media/blog-8a.c58227d9.jpg";